export default "__VITE_ASSET__Cmq4rKJI__"